import { gql } from "@/__generated__/gql";

export const UPDATE_PROFILE_ANSWER_MUTATION = gql(`
  mutation UpdateProfileAnswer(
    $userId: ID!
    $profileAnswerId: ID!
    $answer: String!
  ) {
    updateUserProfileAnswerMutation(input: {
      userId: $userId
      profileAnswerId: $profileAnswerId
      answer: $answer
    }) {
      clientMutationId
      profileAnswer {
        id
        text
        question {
          id
          text
        }
      }
      errors {
        title
        message
      }
    }
  }
`);
